import React from "react";
import PropTypes from "prop-types";
import EditorCarousel from "../components/carousel/editor_carousel/EditorCarousel";

const LeftPanel = ({
  activeLeftPanel,
  hideTab,
  category,
  aiPanel, // TODO: Deprecated — AI sidebar akışı kaldırılıyor, yerini modal popup'lar alıyor
  libraryCategory,
  filesUploaded,
  setcat,
  toggleFileUpload,
  boxes,
  exercises,
  globalConfig,
  onTitleChanged,
  title,
  containedViews,
  containedViewSelected,
  indexSelected,
  navItemsIds,
  navItems,
  navItemSelected,
  displayMode,
  viewToolbars,
  pluginToolbars,
  boxSelected,
  baseUrl,
  trainingId,
  uploadFunction,
  onNarrationSelect,
  onNarrationDelete,
  onSceneOpen,
  onBoxAdded,
  onIndexSelected,
  onContainedViewNameChanged,
  onContainedViewSelected,
  onContainedViewDeleted,
  onNavItemNameChanged,
  onNavItemAdded,
  onNavItemSelected,
  onNavItemExpanded,
  onNavItemDuplicated,
  onNavItemDuplicatedByPayload,
  onNavItemDeleted,
  onNavItemsDeleted,
  onNavItemReordered,
  carouselShow,
  carouselFull,
  onToggleFull,
  onToggleWidth,
  uploadedTemplates,
  onNavItemsAdded,
  onLibraryCategorySelected,
  onReturnToLayers,
  onSetLibraryCategory,
  onReplacePluginFile,
  onShowServerModal,
  ttiGenerateImageFile,
  ttsGenerateSoundFile,
  onAddBox,
  fileModalResult,
  onAddImageModalToggle,
  onAddAvatarModalToggle,
  onAddSoundModalNewToggle,
  onNavItemToggled,
  assessmentCategory,
  onAssessmentCategorySelected,
  onSetAssessmentCategory,
}) => {
  return (
    <EditorCarousel
      activeLeftPanel={activeLeftPanel}
      hideTab={hideTab}
      category={category}
      aiPanel={aiPanel}
      libraryCategory={libraryCategory}
      filesUploaded={filesUploaded}
      setcat={setcat}
      toggleFileUpload={toggleFileUpload}
      boxes={boxes}
      exercises={exercises}
      globalConfig={globalConfig}
      onTitleChanged={onTitleChanged}
      title={title}
      containedViews={containedViews}
      containedViewSelected={containedViewSelected}
      indexSelected={indexSelected}
      navItemsIds={navItemsIds}
      navItems={navItems}
      navItemSelected={navItemSelected}
      displayMode={displayMode}
      viewToolbars={viewToolbars}
      pluginToolbars={pluginToolbars}
      boxSelected={boxSelected}
      baseUrl={baseUrl}
      trainingId={trainingId}
      uploadFunction={uploadFunction}
      onNarrationSelect={onNarrationSelect}
      onNarrationDelete={onNarrationDelete}
      onSceneOpen={onSceneOpen}
      onBoxAdded={onBoxAdded}
      onIndexSelected={onIndexSelected}
      onContainedViewNameChanged={onContainedViewNameChanged}
      onContainedViewSelected={onContainedViewSelected}
      onContainedViewDeleted={onContainedViewDeleted}
      onNavItemNameChanged={onNavItemNameChanged}
      onNavItemAdded={onNavItemAdded}
      onNavItemSelected={onNavItemSelected}
      onNavItemExpanded={onNavItemExpanded}
      onNavItemDuplicated={onNavItemDuplicated}
      onNavItemDuplicatedByPayload={onNavItemDuplicatedByPayload}
      onNavItemDeleted={onNavItemDeleted}
      onNavItemsDeleted={onNavItemsDeleted}
      onNavItemReordered={onNavItemReordered}
      carouselShow={carouselShow}
      carouselFull={carouselFull}
      onToggleFull={onToggleFull}
      onToggleWidth={onToggleWidth}
      uploadedTemplates={uploadedTemplates}
      onNavItemsAdded={onNavItemsAdded}
      onLibraryCategorySelected={onLibraryCategorySelected}
      onReturnToLayers={onReturnToLayers}
      onSetLibraryCategory={onSetLibraryCategory}
      onReplacePluginFile={onReplacePluginFile}
      onShowServerModal={onShowServerModal}
      ttiGenerateImageFile={ttiGenerateImageFile}
      ttsGenerateSoundFile={ttsGenerateSoundFile}
      onAddBox={onAddBox}
      fileModalResult={fileModalResult}
      onAddImageModalToggle={onAddImageModalToggle}
      onAddAvatarModalToggle={onAddAvatarModalToggle}
      onAddSoundModalNewToggle={onAddSoundModalNewToggle}
      onNavItemToggled={onNavItemToggled}
      assessmentCategory={assessmentCategory}
      onAssessmentCategorySelected={onAssessmentCategorySelected}
      onSetAssessmentCategory={onSetAssessmentCategory}
    />
  );
};

LeftPanel.propTypes = {
  activeLeftPanel: PropTypes.string,
  hideTab: PropTypes.string,
  category: PropTypes.string,
  /** TODO: Deprecated — Bu prop aiPanel sidebar akışını taşıyor, ileride kaldırılacak */
  aiPanel: PropTypes.string,
  libraryCategory: PropTypes.string,
  filesUploaded: PropTypes.array,
  setcat: PropTypes.func.isRequired,
  toggleFileUpload: PropTypes.func.isRequired,
  boxes: PropTypes.object.isRequired,
  exercises: PropTypes.object,
  globalConfig: PropTypes.object.isRequired,
  onTitleChanged: PropTypes.func.isRequired,
  title: PropTypes.string,
  containedViews: PropTypes.object.isRequired,
  containedViewSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  indexSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  navItemsIds: PropTypes.array.isRequired,
  navItems: PropTypes.object.isRequired,
  navItemSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  displayMode: PropTypes.string,
  viewToolbars: PropTypes.object.isRequired,
  pluginToolbars: PropTypes.object,
  boxSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  baseUrl: PropTypes.string,
  trainingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  uploadFunction: PropTypes.func,
  onNarrationSelect: PropTypes.func.isRequired,
  onNarrationDelete: PropTypes.func.isRequired,
  onSceneOpen: PropTypes.func.isRequired,
  onBoxAdded: PropTypes.func.isRequired,
  onIndexSelected: PropTypes.func.isRequired,
  onContainedViewNameChanged: PropTypes.func.isRequired,
  onContainedViewSelected: PropTypes.func.isRequired,
  onContainedViewDeleted: PropTypes.func.isRequired,
  onNavItemNameChanged: PropTypes.func.isRequired,
  onNavItemAdded: PropTypes.func.isRequired,
  onNavItemSelected: PropTypes.func.isRequired,
  onNavItemExpanded: PropTypes.func.isRequired,
  onNavItemDuplicated: PropTypes.func.isRequired,
  onNavItemDuplicatedByPayload: PropTypes.func.isRequired,
  onNavItemDeleted: PropTypes.func.isRequired,
  onNavItemsDeleted: PropTypes.func,
  onNavItemReordered: PropTypes.func.isRequired,
  carouselShow: PropTypes.bool.isRequired,
  carouselFull: PropTypes.bool.isRequired,
  onToggleFull: PropTypes.func.isRequired,
  onToggleWidth: PropTypes.func.isRequired,
  uploadedTemplates: PropTypes.array,
  onNavItemsAdded: PropTypes.func,
  onLibraryCategorySelected: PropTypes.func.isRequired,
  onReturnToLayers: PropTypes.func,
  onSetLibraryCategory: PropTypes.func,
  onReplacePluginFile: PropTypes.func,
  onShowServerModal: PropTypes.func,
  ttiGenerateImageFile: PropTypes.func,
  ttsGenerateSoundFile: PropTypes.func,
  onAddBox: PropTypes.func,
  fileModalResult: PropTypes.object,
  /** Toggle AI Image modal */
  onAddImageModalToggle: PropTypes.func,
  /** Toggle AI Avatar modal */
  onAddAvatarModalToggle: PropTypes.func,
  /** Toggle AI Sound modal */
  onAddSoundModalNewToggle: PropTypes.func,
  /** Toggle navItem visibility (hide/show in visor) */
  onNavItemToggled: PropTypes.func,
  /** Currently selected Assessments-panel category (independent of libraryCategory) */
  assessmentCategory: PropTypes.string,
  /** Select an Assessments-panel category (opens the overlay) */
  onAssessmentCategorySelected: PropTypes.func,
  /** Set/clear the Assessments-panel category from inside the overlay */
  onSetAssessmentCategory: PropTypes.func,
};

export default LeftPanel;
